import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {defineMessages, FormattedMessage} from 'react-intl';
import {
    createPassword as createPasswordAction,
    initCreatePassword as initCreatePasswordAction
} from 'actions/creators/createPassword';
import PasswordForm from './PasswordForm.jsx';
import * as CreatePasswordStage from 'constants/CreatePasswordStage';

const messages = defineMessages({
    success: {
        id: 'create-password.password_changed',
        defaultMessage: 'Пароль изменен'
    }
});

class CreatePasswordModal extends React.Component {
    propTypes = {
        push: React.PropTypes.func.isRequired,
        createPasswordAction: React.PropTypes.func.isRequired,
        initCreatePasswordAction: React.PropTypes.func.isRequired,
        passwordStage: React.PropTypes.number.isRequired
    };

    constructor(props) {
        super(props);

        this.onHandleSubmit = this.onHandleSubmit.bind(this);
        this.onModalClose = this.onModalClose.bind(this);

    }

    onHandleSubmit(data) {
        this.props.createPasswordAction(data);
    }

    onModalClose() {
        this.props.initCreatePasswordAction();
    }

    render() {
        const  {passwordStage} = this.props;

        return (
            <div className='modal--content__wrapper'>
                {passwordStage === CreatePasswordStage.INIT && <PasswordForm submitAction={this.onHandleSubmit}/>}
                {passwordStage === CreatePasswordStage.SUCCESS &&
                <FormattedMessage {...messages.success}>
                    {(m) => <span className="modal--auth-recover__title__span">{m}</span>}
                </FormattedMessage>
                }
            </div>
        )
    }
}

export default connect(null, {
    createPasswordAction,
    initCreatePasswordAction,
    push
})(CreatePasswordModal);


// WEBPACK FOOTER //
// ./js/shared/components/CreatePassword/index.js